import { ShippingAddress } from "../user/user";
import dayjs from "dayjs";
import { EVatRate } from "../product/product";

export enum EPaymentMethod {
    CreditCard,
    Other
}


export enum EPaymentStatus {
    NotPaid,
    Paid,
    PaymentError,
}

export enum EOrderStatus {
    AwaitingPayment,
    Processing,
    Shipped,
    Delivered
}

export class Order {
    constructor() {
        this.id = '';
        this.createdOn = '';
        this.owningUser = '';
        this.items = new Array<OrderItem>();
        this.vatTotal = 0;
        this.totalWithoutTaxes = 0;
        this.total = 0;
        this.paymentMethod = EPaymentMethod.Other;
        this.paymentStatus = EPaymentStatus.NotPaid;
        this.shippingTotal = 0;
        this.shippingModeUsed = "";
        this.internalPaymentMethod = "";
        this.status = EOrderStatus.AwaitingPayment;
        this.shippingDate = dayjs();
        this.shippingAddress = new ShippingAddress();
        this.checkoutId = '';
        this.notes = '';

    }
    id: string;
    createdOn: string;
    owningUser: string;
    items: Array<OrderItem>;
    vatTotal: number;
    totalWithoutTaxes: number;
    total: number;
    paymentMethod: EPaymentMethod;
    paymentStatus: EPaymentStatus;
    internalPaymentMethod: string;
    shippingDate: dayjs.Dayjs;
    shippingAddress: ShippingAddress;
    shippingTotal: number;
    shippingModeUsed: string;
    status: EOrderStatus;
    checkoutId: string;
    notes: string | null;
}

export class OrderItem {
    constructor() {
        this.id = '';
        this.name = '';
        this.sku = '';
        this.productId = '';
        this.taxSiae = 0;
        this.quantity = 0;
        this.vatRate = EVatRate.Vat22;
        this.vatTotal = 0;
        this.price = 0;
        this.orderItemConfigurations = new Array<OrderItemConfiguration>()
    }
    id: string;
    productId: string;
    name: string;
    sku: string;
    quantity: number;
    taxSiae: number;
    price: number;
    vatRate: EVatRate;
    vatTotal: number;
    orderItemConfigurations: Array<OrderItemConfiguration>;
}

export class OrderItemConfiguration {
    constructor() {
        this.id = '';
        this.item = new OrderItem();
        this.name = '';
        this.addonSku = '';
        this.selectedOptionName = '';
        this.selectedOptionSku = '';
        this.selectedOptionId = '';
        this.selectedPrice = 0;
        this.sequence = 0;
        this.selectedQuantity = 0;
    }
    id: string;
    item: OrderItem;
    name: string;
    addonSku: string;
    selectedOptionName: string;
    selectedOptionSku: string;
    selectedOptionId: string | null;
    selectedPrice: number;
    sequence: number;
    selectedQuantity: number;
}

export function calculateOrderPrice(order: Order)  {
    let total = 0;
    order.items.forEach((orderItem: OrderItem) => {
        total += orderItem.price;
    })
    return total;
}
